<template>
     <div style="background: #fff;">
      <div style="padding-top: 20px;">
          <ItemList ref="ItemList"></ItemList>
      </div>
    </div>
</template>

<script>
import eventBus from '@/utils/eventBus.js'
import ItemList from '@/components/ItemList.vue'
import {homeListPage} from '@/api/index'
  export default {
    components: { ItemList },
    data(){
      return{
        pageNum:1,
      }
    },
    beforeDestroy(){
      eventBus.$off('search');
    },
    created(){
      eventBus.$on('search',(message)=>{
        this.$route.query.keyword=message.input
        this.homeListPage()
      })
      this.homeListPage()
    },
    methods:{
      //数据列表
      homeListPage(pageNum){
        homeListPage({
            pageSize:10,
            pageNum:pageNum||this.pageNum,
            biddingType:this.$route.query.keyword?'':this.$route.query.biddingType,
            projectType:'',
            searchValue:this.$route.query.keyword||'',
            sectionStautsList:this.$route.query.biddingType==1?'1,2':this.$route.query.biddingType==0?'7,8,2':''
        }).then(res=>{
            this.$refs.ItemList.tableData=res.rows
            this.$refs.ItemList.total=res.total
            this.$refs.ItemList.Loading=res.total?false:true
        })
      },
    }
};
  </script>
